import { services } from '../../../../constants/services';
import { getByQuery } from '../../../../utils/api';

export class GetWidgetsWithPaginationService {
  async run(params: any) {
    const response :any= await getByQuery<any[]>(`${services['chat-instances']}/list-with-pagination`, params);
    return  {data:response.data, ...response.pagination};
  };
};